import { Suspense, lazy } from 'react';
import type { BattleViewProps } from './BattleViewProps.js';
import { BattleGrid } from './BattleGrid.js';
import { getRenderMode } from './renderMode.js';

const BattleScene3D = lazy(() =>
  import('./BattleScene3D.js').then((module) => ({ default: module.BattleScene3D })),
);

export function BattleRenderer(props: BattleViewProps) {
  if (getRenderMode() === '2d') {
    return <BattleGrid {...props} />;
  }

  return (
    <Suspense fallback={<BattleGrid {...props} />}>
      <BattleScene3D {...props} />
    </Suspense>
  );
}
